import React from 'react'

export const BulkActions = ({ onLabel, offLabel, onTurnOn, onTurnOff, canTurnOn, canTurnOff }) => (
    <div className="rt-bulk-actions">
        <button type="button" className="btn btn-sm btn-outline-primary" disabled={!canTurnOn} onClick={onTurnOn}>
            {onLabel}
        </button>
        <button type="button" className="btn btn-sm btn-outline-primary" disabled={!canTurnOff} onClick={onTurnOff}>
            {offLabel}
        </button>
    </div>
)
